/* ==========================================================================
   ProductCardLeiRxjs > Client > Store > Actions
   ========================================================================== */

/* Types */
const DESTROY = 'PRODUCT_CARD_LEI_RXJS::DESTROY';
const ACTIVE_TAB = 'PRODUCT_CARD_LEI_RXJS::ACTIVE_TAB';
const DISABLE_TAB = 'PRODUCT_CARD_LEI_RXJS::DISABLE_TAB';

/* Actions */
const activeTab = payload => ({ type: ACTIVE_TAB, payload });
const disableTab = payload => ({ type: DISABLE_TAB, payload });

/* Actions */
const destroy = () => ({ type: DESTROY });

/* Exports */
module.exports = {
    types: {
        DESTROY,
        ACTIVE_TAB,
        DISABLE_TAB
    },
    actions: {
        destroy,
        activeTab,
        disableTab
    }
};
